import Meta from '@/components/common/Meta'

import MovingBoxesShippingServicesPage from '@/v2/components/pages/landing-pages/moving-boxes-shipping-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/moving-boxes-shipping-services-page'

interface MovingBoxesShippingServicesPageProps {}

const Page: React.FC<MovingBoxesShippingServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.moving_boxes_shipping_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.moving_boxes_shipping_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.moving_boxes_shipping_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <MovingBoxesShippingServicesPage />
    </>
  )
}

export default Page
